import { Theme } from '@mui/material';

import { ContentfulBackground, Maybe } from '@/types';
import { FocalPointImage } from '@/graphql/__generated/sdk';
import { resolveContentfulBgColor } from '@/utils';

export const getNestedContentHeroWrapperStyles = ({
	focalPointImageSmallScreen,
	backgroundColorSmallScreen,
	theme,
}: {
	focalPointImageSmallScreen?: Maybe<FocalPointImage>;
	backgroundColorSmallScreen?: Maybe<string>;
	theme: Theme;
}) => {
	const getBackgroundStyles = (
		focalPointImageSmallScreen?: Maybe<FocalPointImage>,
		backgroundColorSmallScreen?: Maybe<string>
	) => {
		if (focalPointImageSmallScreen && focalPointImageSmallScreen.image?.url) {
			return {
				backgroundImage: `url(${focalPointImageSmallScreen.image.url})`,
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat',
			};
		}

		if (backgroundColorSmallScreen) {
			const resolvedBgColor = resolveContentfulBgColor(backgroundColorSmallScreen as ContentfulBackground, theme);
			if (resolvedBgColor) {
				return { background: resolvedBgColor };
			}
		}

		return {};
	};

	return {
		width: '100%',
		maxWidth: '100%',
		display: 'flex',
		[theme.breakpoints.down('md')]: {
			minHeight: '53.125rem',
			height: 'auto',
			justifyContent: 'center',
			alignItems: 'flex-start',
			padding: '5% 2% 8%',
			...getBackgroundStyles(focalPointImageSmallScreen, backgroundColorSmallScreen),
		},
		[theme.breakpoints.down('sm')]: {
			padding: '5% 2% 10%',
		},
		[theme.breakpoints.up('md')]: {
			minHeight: 'calc(100vh - 200px)',
			justifyContent: 'flex-start',
			alignItems: 'center',
			padding: '5% 5%',
		},
	};
};

export const resolveEyebrowTypographyVariant = (eyebrowStyle: string) => {
	if (eyebrowStyle === 'Promo') return 'bodyXLBook';
	return 'bodyLargeBook';
};

export const getEyebrowStyles = (eyebrowStyle: string) => {
	return {
		fontWeight: eyebrowStyle === 'Promo' ? 700 : 400,
		fontSize: { md: '1.125rem', xs: '1rem' },
	};
};

export const getBodyDocPropsVariant = (isSmallScreen: boolean, bodySize: string) => {
	if (isSmallScreen) return 'bodyMediumBook';
	if (bodySize === 'Medium') return 'bodyLargeBook';
	return 'bodyXLBook';
};
